/* Local-only navigation state. Links and content work without JavaScript. */
if (!customElements.get('trust-center-page')) {
  customElements.define('trust-center-page', class extends HTMLElement {
    connectedCallback() {
      // Compatibility for saved Trust Center links. A Shopify Admin 301 is
      // still required before retiring the old page; this is not an HTTP redirect.
      if (this.dataset.migrateTo && !window.Shopify?.designMode) {
        const destination = new URL(this.dataset.migrateTo, location.origin);
        destination.search = location.search;
        destination.hash = location.hash;
        if (destination.origin === location.origin && destination.pathname !== location.pathname) {
          location.replace(destination.href);
          return;
        }
      }
      this.links = [...this.querySelectorAll('[data-trust-anchor]')];
      if (!this.links.length) return;
      this.onClick = (event) => {
        const link = event.target.closest('[data-trust-anchor]');
        if (link && this.contains(link)) this.setActive(link.hash);
      };
      this.addEventListener('click', this.onClick);
      this.onHash = () => this.setActive(location.hash);
      window.addEventListener('hashchange', this.onHash);
      this.onHash();
      if (!('IntersectionObserver' in window)) return;
      const visible = new Set();
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => entry.isIntersecting ? visible.add(entry.target) : visible.delete(entry.target));
        // Keep an explicitly chosen anchor active while it is visible, even
        // when the preceding section shares the viewport after a disclosure.
        const current = [...visible].find(section => `#${section.id}` === location.hash)
          || [...visible].sort((a, b) => Math.abs(a.getBoundingClientRect().top - 130) - Math.abs(b.getBoundingClientRect().top - 130))[0];
        if (current) this.setActive(`#${current.id}`);
      }, { rootMargin: '-130px 0px -45% 0px', threshold: 0 });
      this.querySelectorAll('.trust-center__section').forEach(section => this.observer.observe(section));
    }
    setActive(hash) {
      if (!this.links.some(link => link.hash === hash)) return;
      this.links.forEach(link => {
        if (link.hash === hash) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      window.removeEventListener('hashchange', this.onHash);
      this.observer?.disconnect();
    }
  });
}
